import { $, _, Foundation } from "../../../vendor";
import { Notification, Biscuit } from "../../utils";
import InboomaBaseView from "../InboomaBaseView";

import Contingent from "../../models/Contingent";

import ContingentsItemProgressTpl from "../../templates/contingents/ContingentsItemProgressTpl.html";

export default InboomaBaseView.extend({
  /**
   * Renders a progress bar indicating contingents availability
   * Offers a dropdown select-panel to change contingents avails
   */

  template: ContingentsItemProgressTpl,

  ui: {
    dropdown: ".dropdown-pane",
    formPlusButton: ".plus-button",
    formMinusButton: ".minus-button",
    saveButton: ".save-button",
  },

  events: {
    "click @ui.formPlusButton": "_clickPlusButton",
    "click @ui.formMinusButton": "_clickMinusButton",
    "click @ui.saveButton": "_saveForm",
  },

  templateContext() {
    const contingent_numbers = this.model.getNumbersByToday();
    return {
      number_active: typeof contingent_numbers !== "undefined" ? contingent_numbers.number : 0,
      client_id: Biscuit.get("user.client_id"),
    };
  },

  initialize() {
    this.render();
  },

  _clickPlusButton(target) {
    this.getUI("saveButton").removeClass("hollow");

    const parent = $(target.currentTarget).closest(".plus-minus-input"),
      context = parent.attr("data-inb-context");

    let val = Number(parent.find("input").val());

    if (context == "number_total") {
      parent.find("input").val(++val);
    } else {
      if (++val <= Number(this.$el.find(".contingent__number_total input").val())) {
        parent.find("input").val(val);
      }
    }
  },

  _clickMinusButton(target) {
    const parent = $(target.currentTarget).closest(".plus-minus-input"),
      context = parent.attr("data-inb-context");

    let val = Number(parent.find("input").val());

    // Do not allow falling down the actual "physical"
    // resources count number or 0
    if (val <= 0 || (--val < this.model.get("resources").length && context == "number_total")) {
      return;
    }

    parent.find("input").val(val);

    if (context == "number_total") {
      if (Number(this.$el.find(".contingent__number_active input").val()) >= val) {
        this.$el.find(".contingent__number_active input").val(val);
      }
    }

    this.getUI("saveButton").removeClass("hollow");
  },

  _saveForm() {
    const that = this;

    this.getUI("saveButton").html(this.getUI("saveButton").html() + "...");
    //this.$el.find('*').not(this.getUI('saveButton')[0]).fadeOut('slow');

    this.model.save(
      {
        number_total: Number(that.$el.find(".contingent__number_total input").val()),
        number_active: Number(that.$el.find(".contingent__number_active input").val()),
      },
      {
        patch: true,
        silent: true, // do not trigger render on parent collection
        success: (model, response) => {
          model = new Contingent(model.toJSON());

          that.dropdown.close();
          that.render();

          new Notification({
            message: that.t("updated_${a}", { a: that.t("contingent") }, "capital"),
            duration: 5000,
            closeable: true,
            icon: "fi fi-check",
          });
        },
      },
    );
  },

  /*onRender () {

    const that = this,
          dd = this.getUI('dropdown');

    window.requestAnimationFrame(function() {
      that.dropdown = new Foundation.Dropdown(dd);
    });

  }*/
});
